<template>
   <div>
    <b-container v-if="isLoading" class="text-center d-flex justify-content-center">
      <b-form>
        <br><br><br>
        <h5>loading</h5>
        <br>
        <b-spinner style="color: rgb(109,122,82) !important"
          variant="warning"
        ></b-spinner>
      </b-form>
    </b-container>
    <div v-else>
      <b-container fluid v-if="this.inSession">
        <b-row>
          <b-col style="padding:0" align="center">
            <div class="menu-top" style="text-align:center">
              <p><b><span style="color: rgb(195,147,130)">WYNE</span></b>CELLAR</p>
            </div>
            <div>
              <img class="menu-overlay"
                :src="require('@/assets/img/menu.png')""
                v-b-toggle.menu-sidebar
              >
            </div>
            <hr>
          </b-col>
        </b-row>
        <p class="w-pagetitle" style="margin-left:20px;margin-right:5px; text-align:right;">{{ translate("library") }}</p>

        <br>
        <h1 class="main-title"><b><span style="color: rgb(195,147,130)">WYNE</span></b><span style="color: black">LOVER</span></h1>
        <b-row class="justify-content-center" style="position:relative; top:-15px">
          <p class="t-title">{{ translate("search wine in database") }}</p>
        </b-row>

        <b-row>
          <b-col md="10" style="padding:0" align="center">
            <LibrarySearch/>
          </b-col>
        </b-row>
        <b-sidebar 
          id="menu-sidebar" 
          backdrop
          backdrop-variant="dark" 
          no-header
          shadow
        >
          <template #default="{ hide }">
            <div style="display: flex; align-items: center;">
              <div style="display: flex;align-items: center; width:25 px">
                <b-dropdown 
                  left 
                  split 
                  text="language" 
                  class="language-dropdown" 
                  toggle-class="toggle-language" 
                  split-class="split-language" 
                  style="display: flex;font-size: 12px;margin:15px 0 0 10px"
                >
                  <template #button-content>
                    <img
                      :src="currentLanguageFlag"
                      style="width:28px; height:19px; border-radius:2px;"
                    >
                  </template>

                  <b-dropdown-item @click="selectLanguage('en')">
                    <img :src="require('@/assets/img/flags/english.png')" style="width: 37px; height: 25px;">
                    English
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('fr')">
                    <img :src="require('@/assets/img/flags/francais.png')" style="width: 37px; height: 25px;">
                    Français (French)
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('de')">
                    <img :src="require('@/assets/img/flags/deutsch.png')" style="width: 37px; height: 25px;">
                    Deutsch (German)
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('es')">
                    <img :src="require('@/assets/img/flags/spanish.png')" style="width: 37px; height: 25px;">
                    Español (Spanish)
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('it')">
                    <img :src="require('@/assets/img/flags/italian.png')" style="width: 37px; height: 25px;">
                    Italiano (Italian)
                  </b-dropdown-item>
                  <b-dropdown-item @click="selectLanguage('nl')">
                      <img :src="require('@/assets/img/flags/dutch.png')" style="width: 37px; height: 25px;">
                      Nederlands (Dutch)
                    </b-dropdown-item>
                    <b-dropdown-item @click="selectLanguage('pt')">
                      <img :src="require('@/assets/img/flags/portuguese.png')" style="width: 37px; height: 25px;">
                      Português (Portuguese)
                    </b-dropdown-item>
                </b-dropdown>
              </div>
              <div style="display: flex; align-items: center;">
                <p style="margin:20px 0 0 40px;"><b><span style="color: rgb(195,147,130)">WYNE</span></b>CELLAR</p>
              </div>
              <div style="display: flex; align-items: center; width:25 px">
                <img class="menu-overlay"
                  :src="require('@/assets/img/close.png')" 
                  style="width: 25px; height: 25px; cursor: pointer;" 
                  @click="hide"
                >
              </div>
            </div>
            <hr>
            <Menu/> 
          </template>
        </b-sidebar>      
      </b-container>
      <NoAccess v-else></NoAccess>
    </div>
  </div>
</template>

<script>
  import NoAccess from '@/components/NoAccess.vue';
  import Menu from '@/components/MenuMobile.vue';
  import {wordlist,translate_word} from '../assets/js/translate.js';

  import Users from '../Users.js';
  import LibrarySearch from '@/components/LibrarySearch_Mobile.vue';

  import Wines_Search from '../Wines_Search.js'

  export default {
    name: "Library",
    components: {
      NoAccess,
      Menu,
      LibrarySearch,
    },
    computed : {
      inSession() {
        return this.$store.state.inSession
      },
      currentUser() {
        return this.$store.state.user
      },
      currentUserID() {
        return this.$store.state.user_id
      },
      currentLanguage() {
        return this.$store.state.language
      },
      currentLanguageFlag() {
        const flags = {
          en: require('@/assets/img/flags/english.png'),
          fr: require('@/assets/img/flags/francais.png'),
          de: require('@/assets/img/flags/deutsch.png'),
          es: require('@/assets/img/flags/spanish.png'),
          it: require('@/assets/img/flags/italian.png'),
          nl: require('@/assets/img/flags/dutch.png'),
          pt: require('@/assets/img/flags/portuguese.png')
        }
        return flags[this.currentLanguage] || flags.en
      },  
    },
    data() {
      return {
        debug : false,        
        isLoading : true,

        wines: [],

        keyword_forName: '',
        search_forName:true,
        keyword_forRegion: '',
        search_forRegion:false,
        keyword_forAppellation: '',
        search_forAppellation:false,
        keyword_forGrapes: '',
        search_forGrapes:false,

        showSearchZone: true,
        showResultZone: false,

        // Validation Logic
        nameValid : true,
        nameFeedback : '',

        leftVisible:false,
        rightVisible:false,
        screenCount:0,
        wineCount:0,
        wines_perScreen:6,

        isValid : true,
      }
    }, 
    async mounted() {
      this.isLoading = false;
    },
    methods:{
      async onSearch() {
        if (this.debug) console.log("Library in onSearch: Search pressed")
        this.wines = [];
        this.screenCount = 0;
        this.leftVisible = false;
        this.rightVisible = false;

        let postdata = {
          "name": this.keyword_forName,
          "region":this.keyword_forRegion,
          "appellation":this.keyword_forAppellation,
          "grapes":this.keyword_forGrapes,
          "skip":0,
          "limit":this.wines_perScreen};
        await Wines_Search.count(postdata)
        .then(response=>{
          if (this.debug) console.log("Library in onSearch: succesful wines search count = ", response)
          this.wineCount = response
        })
        .catch(error=>{
          if (this.debug) console.log("Library in onSearch: catch Wines_Search.count error = ", error)
          return
        })

        await Wines_Search.list(postdata)
        .then(response=>{
          if (this.debug) console.log("Library in onSearch: succesful wines search response = ", response)
            for (let i = 0; i < response.length ; i++) {
              this.wines[i] = response[i]
            }
        })
        .catch(error=>{
          if (this.debug) console.log("Library in onSearch: catch Wines_Search.list error = ", error)
          return
        })

        if (this.debug) console.log("Library in onSearch: wines = ", this.wines)
        if (this.wines.length > 0) this.showResultZone = true;
        if (this.wineCount > (this.screenCount+1)*this.wines_perScreen) {
          this.rightVisible = true;
        } else {
          this.rightVisible = false;
        }
        this.$forceUpdate();
      },
      async onLeft() {
        if (this.debug) console.log("Library in onLeft: Left clicked")
        this.screenCount--;

        this.wines = [];
        let postdata = {
          "name": this.keyword_forName,
          "region":this.keyword_forRegion,
          "appellation":this.keyword_forAppellation,
          "grapes":this.keyword_forGrapes,
          "skip":this.screenCount*this.wines_perScreen,
          "limit":this.wines_perScreen};
        await Wines_Search.list(postdata)
        .then(response=>{
          if (this.debug) console.log("Library in onSearch: succesful wines search response = ", response)
            for (let i = 0; i < response.length ; i++) {
              this.wines[i] = response[i]
            }
        })
        .catch(error=>{
          if (this.debug) console.log("Library in onSearch: catch Wines_Search.list error = ", error)
          return
        })

        if (this.debug) console.log("Library in onRight: wines = ", this.wines)
        if (this.wines.length > 0) this.showResultZone = true;
        if (this.screenCount > 0) {
          this.leftVisible = true;
        } else {
          this.leftVisible = false;
        }
        if (this.wineCount > (this.screenCount+1)*this.wines_perScreen) {
          this.rightVisible = true;
        } else {
          this.rightVisible = false;
        }
        this.$forceUpdate();
      },
      async onRight() {
        if (this.debug) console.log("Library in onRight: Right clicked")
        this.screenCount++;

        this.wines = [];
        let postdata = {
          "name": this.keyword_forName,
          "region":this.keyword_forRegion,
          "appellation":this.keyword_forAppellation,
          "grapes":this.keyword_forGrapes,
          "skip":this.screenCount*this.wines_perScreen,
          "limit":this.wines_perScreen};
        await Wines_Search.list(postdata)
        .then(response=>{
          if (this.debug) console.log("Library in onSearch: succesful wines search response = ", response)
            for (let i = 0; i < response.length ; i++) {
              this.wines[i] = response[i]
            }
        })
        .catch(error=>{
          if (this.debug) console.log("Library in onSearch: catch Wines_Search.list error = ", error)
          return
        })

        if (this.debug) console.log("Library in onRight: wines = ", this.wines)
        if (this.wines.length > 0) this.showResultZone = true;
        if (this.screenCount > 0) {
          this.leftVisible = true;
        } else {
          this.leftVisible = false;
        }
        if (this.wineCount > (this.screenCount+1)*this.wines_perScreen) {
          this.rightVisible = true;
        } else {
          this.rightVisible = false;
        }
        this.$forceUpdate();
      },

      async selectLanguage(language) {
        let local_debug = false
        if (local_debug || this.debug) console.log("TastingsOverview.selectLanguage: START");
        this.$store.commit('setLanguage',language)

        let user = this.currentUser
        let user_id = this.currentUserID
        user.language = language
        await Users.update(user_id, user)
        .then(response => {
          if (local_debug || this.debug) console.log ("TastingsOverview.selectLanguage: user ",user.email," updated with response ", response)
        })
        .catch(error => {
          if (local_debug || this.debug) console.log('TastingsOverview.selectLanguage: catch await Users.update ERROR : ', error);
        })

        if (local_debug || this.debug) console.log("TastingsOverview.selectLanguage: STOP");
      },
      

      translate(string) {
        return translate_word(string, this.currentLanguage);
      },
      
      doNothing() {
      },
    }
  }    
</script>

<style>
@import url("../assets/styles/wynestyle.css");
</style>